// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6a1aaf01","524":"00b029bb","865":"c5bbc344"}[chunkId] + ".chunk.js";
};